export default __webpack_public_path__ + "static/media/lightning.143382e1.svg";